var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.menu.children !== undefined || _vm.menu.groups !== undefined
    ? _c(
        "q-submenu",
        {
          attrs: {
            amn: "sub-menu",
            index: _vm.menu.index,
            "q-menu-key": _vm.menu.key,
          },
        },
        [
          _c(
            "template",
            { slot: "title" },
            [
              _vm.menu.icon
                ? _c("font-awesome-icon", {
                    attrs: { icon: ["fas", _vm.menu.icon] },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                _vm._v(_vm._s(_vm.menu.caption)),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.menu.groups !== undefined
            ? _vm._l(_vm.menu.groups, function (group) {
                return _c(
                  "q-menu-item-group",
                  { key: group.caption, attrs: { "q-menu-key": group.key } },
                  [
                    _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                      _vm._v("\n        " + _vm._s(group.caption) + "\n      "),
                    ]),
                    _vm._v(" "),
                    group.members
                      ? _vm._l(group.members, function (m) {
                          return _c("q-menu-bar-item", {
                            key: m.index,
                            attrs: { menu: m },
                          })
                        })
                      : _vm._e(),
                  ],
                  2
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.menu.children !== undefined
            ? _vm._l(_vm.menu.children, function (child) {
                return _c("q-menu-bar-item", {
                  key: child.index,
                  attrs: { menu: child },
                })
              })
            : _vm._e(),
        ],
        2
      )
    : _c(
        "q-menu-item",
        { attrs: { index: _vm.menu.index, "q-menu-key": _vm.menu.key } },
        [
          _vm.menu.icon
            ? _c("font-awesome-icon", {
                attrs: { icon: ["fas", _vm.menu.icon] },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.menu.caption))]),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }